import { useEffect, useMemo } from 'react';
import { useLoader, useThree } from '@react-three/fiber';
import * as THREE from 'three';

const ImageSphere = (props) => {
    const { url, addNewHotspot } = props;
    
    let texture = useLoader(THREE.TextureLoader, url);
    
    const { mouse } = useThree();
    const { gl } = useThree();
    
    useEffect(() => void gl.setPixelRatio(window.devicePixelRatio || 2), [gl]);
    
    useMemo(() => {
        texture.encoding = THREE.LinearEncoding;
    }, [texture]);


    const handleCanvasClick = (e) => {
        console.log('img sphere clicked ', e, mouse)
        addNewHotspot(e.point)
    };


    return (
        <mesh {...props} scale={[-1, 1, 1]} onDoubleClick={handleCanvasClick}>
            <sphereBufferGeometry attach="geometry" args={[1000, 60, 40]} />
            <meshBasicMaterial 
                attach="material" 
                side={THREE.BackSide} 
                map={texture} 
                transparent={false} 
                fog={false}
                color={0xffffff}
                depthWrite={false} 
            />
        </mesh>
    );
};


export default ImageSphere;